import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\CreateCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/CreateCommandRunController.php
* @route '/api/sa-management/command-runner/runs'
*/
const CreateCommandRunController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCommandRunController.url(options),
    method: 'post',
})

CreateCommandRunController.definition = {
    methods: ["post"],
    url: '/api/sa-management/command-runner/runs',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SAManagement\CreateCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/CreateCommandRunController.php
* @route '/api/sa-management/command-runner/runs'
*/
CreateCommandRunController.url = (options?: RouteQueryOptions) => {
    return CreateCommandRunController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\CreateCommandRunController::__invoke
* @see app/Http/Controllers/SAManagement/CreateCommandRunController.php
* @route '/api/sa-management/command-runner/runs'
*/
CreateCommandRunController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateCommandRunController.url(options),
    method: 'post',
})

export default CreateCommandRunController